import React, { useEffect } from "react";
import OurStory from "./OurStory";
import ProductShowcase from "./ProductShowcase";
import WhyChooseUs from "./WhyChooseUs";
import FeaturedMoments from "./FeaturedMoments";
import LoyaltyInvite from "./LoyaltyInvite";
import EmotionBrowser from "./EmotionBrowser";
import FinalCTA from "./FinalCTA";
import HeroCarousel from "./HeroCarousel";
import Banner from "./Banner";

const LandingPage = () => {
  useEffect(() => {
    document.title = "Home";
  }, []);

  return (
    <>
      <HeroCarousel />
      <OurStory />
      <ProductShowcase />
      <Banner />
      <WhyChooseUs />
      <FeaturedMoments />
      <LoyaltyInvite />
      <EmotionBrowser />
      {/* <FinalCTA /> */}
    </>
  );
};

export default LandingPage;
